import React, { HTMLInputAutoCompleteAttribute } from "react";
import { FieldValues, Path } from "react-hook-form";

import { Input } from "@/components/Form/Base/input.component";

import { useAutofill } from "../../Utils/useAutofill";
import { BaseField } from "../BaseField/BaseField.component";
import { FormValuesExploded } from "../formField.types";

export type TextFieldProps<T extends FieldValues> = FormValuesExploded<T> & {
    placeholder?: string;
    autoComplete?: HTMLInputAutoCompleteAttribute;
    disabled?: boolean;
    ref?: React.Ref<HTMLInputElement>;
    maxLength?: number;
};

const TextField = <T extends FieldValues>({
    name,
    label,
    microCopy,
    required,
    placeholder,
    autoComplete,
    disabled,
    hideLabel,
    hideMicroCopy,
    optionalIndication,
    requiredIndication,
    maxLength,
    className,
    ref,
    test
}: TextFieldProps<T>) => {
    const { handleOnAutofill } = useAutofill<T>(name);

    return (
        <BaseField<T, Extract<Path<T>, string>>
            name={name}
            label={label}
            microCopy={microCopy}
            required={required}
            hideLabel={hideLabel}
            hideMicroCopy={hideMicroCopy}
            optionalIndication={optionalIndication}
            requiredIndication={requiredIndication}
        >
            {({ field, fieldState }) => {
                return (
                    <Input
                        {...field}
                        className={className}
                        type="text"
                        inputMode="text"
                        id={name}
                        placeholder={placeholder}
                        autoComplete={autoComplete}
                        valid={fieldState.isValid}
                        invalid={fieldState.isInvalid}
                        disabled={disabled}
                        data-test={test}
                        ref={ref}
                        maxLength={maxLength}
                        onAutofill={handleOnAutofill}
                    />
                );
            }}
        </BaseField>
    );
};

export { TextField };
